import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/modules/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CacConsultComponent } from './cac-consult/cac-consult.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [],
    declarations: [CacConsultComponent],
    providers: [],
})
export class CacConsultModule { }
